import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Container,
  Typography,
  Box,
  Grid,
  Paper,
  LinearProgress,
} from "@mui/material";
import {
  fetchCrmStats,
  crmSliceSelector,
} from "../../../redux/features/crmSlice";

export default function CRMDashboard() {
  const dispatch = useDispatch();
  const crmState = useSelector((state) => crmSliceSelector(state));
  const { crmStats, crmStatsLoading } = crmState;
  const fetchAttemptedRef = useRef(false);

  useEffect(() => {
    if (!crmStatsLoading && !fetchAttemptedRef.current) {
      fetchAttemptedRef.current = true;
      dispatch(fetchCrmStats());
    }
  }, [dispatch, crmStatsLoading]);

  const organizationStats = crmStats.organizationStats || {};
  const eventStats = crmStats.eventStats || {};
  const orderStats = crmStats.orderStats || {};

  return (
    <Container>
      <Typography variant="h2" paddingTop={"20px"}>
        CRM Dashboard
      </Typography>
      {crmStatsLoading && <LinearProgress sx={{ marginTop: 2 }} />}
      <Box marginTop={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6">Total Organizations</Typography>
              <Typography variant="h4" marginTop={2}>
                {organizationStats.organizationCount ?? "-"}
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6">Total Events</Typography>
              <Typography variant="h4" marginTop={2}>
                {eventStats.eventCount ?? "-"}
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6">Total Orders</Typography>
              <Typography variant="h4" marginTop={2}>
                {orderStats.orderCount ?? "-"}
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
